import { hashCode } from 'src/filters';

// Die drei Sub-Listen-Ansichten (Offen/Meine/Alle), deren Scroll-Position pro virtualListId gehalten wird.
const MODULE_LIST_VIEW_SCROLL_SUFFIXES = ['Open', 'Mine', 'All'] as const;

// Baut die pro-Instanz eindeutige virtualListId-Basis EXAKT wie GenericActivityListTabPanel (resolvedVirtualListId):
// `${baseVirtualListId}${hashCode(genericListIdentifier)}`. Muss deckungsgleich mit GenericActivityListTabPanel.vue
// bleiben, sonst räumt der Dispose-Pfad die falschen Scroll-Slots ab.
export const buildInstanceResolvedVirtualListId = (baseVirtualListId: string, genericListIdentifier: string): string =>
	`${baseVirtualListId}${hashCode(genericListIdentifier)}`;

// Die drei view-suffixierten (Open/Mine/All) Scroll-Slot-Keys einer isolierten Listen-Instanz — genau die Keys,
// unter denen GenericActivityList seine Scroll-Positionen im genericActivityList-Store ablegt.
export const buildInstanceScrollSlotKeys = (
	baseVirtualListId: string,
	genericListIdentifier: string
): Array<string> => {
	const resolvedVirtualListId = buildInstanceResolvedVirtualListId(baseVirtualListId, genericListIdentifier);

	return MODULE_LIST_VIEW_SCROLL_SUFFIXES.map((suffix) => `${resolvedVirtualListId}${suffix}`);
};
